<template>
    <main class="flex-1 relative overflow-y-auto py-6 focus:outline-none" tabindex="0">
        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 px-5">
            <div class="md:flex md:items-center md:justify-between">
                <div class="flex-1 min-w-0">
                    <h1 class="py-0.5 text-2xl font-semibold text-gray-900">{{ $t('Process steps') }}</h1>
                </div>
            </div>
        </div>
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <loading :status="loading"/>

            <div class="my-6 bg-white shadow overflow-hidden sm:rounded" v-if="tabs.length > 0">
                <div class="bg-white px-4 py-3 flex items-center justify-between border-b border-gray-200 sm:px-6">
                    <div>
                        <div class="flex rounded shadow-sm">
                            <span class="relative inline-flex shadow-sm rounded-md">
                                <select
                                    id="category"
                                    v-model="activeTab"
                                    :aria-label="$t('Category')"
                                    class="block form-select w-full pl-3 pr-9 py-2 rounded-md border border-gray-300 bg-white text-sm leading-5 font-medium text-gray-700 hover:text-gray-500 focus:z-10 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-100 active:text-gray-700 transition ease-in-out duration-150"
                                >
                                    <option v-for="tab in tabs" :key="tab.slug" :value="tab.slug">
                                        {{ tab.title }}
                                    </option>
                                </select>
                            </span>
                        </div>
                    </div>
                </div>
                <div>
                <table class="min-w-full">
                    <tbody>
                    <tr
                        v-for="(processStep, index) in activeTabItems"
                        :key="processStep.id"
                        :class="index !== 0 ? 'border-t border-gray-200' : ''"
                    >
                        <td class="px-0 py-0">
                            <router-link
                                :to="'/workspace/admin/settings/process-steps/' + processStep.id + '/edit'"
                                class="flex items-center justify-between w-full px-4 py-4 sm:px-6 hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition duration-150 ease-in-out"
                            >
                                <div class="min-w-0 flex-1 flex items-center">
                                    <div class="flex-shrink-0">
                                        <svg-vue :style="{color: processStep.color}" class="h-5 w-5" icon="font-awesome.circle-solid"></svg-vue>
                                    </div>
                                    <div class="min-w-0 flex-1 px-4">
                                        <div class="text-sm font-medium leading-5 text-gray-900">
                                            {{ index + 1 }}. {{ processStep.name }}
                                        </div>
                                    </div>
                                </div>
                                <svg-vue class="h-5 w-5 text-gray-400" icon="font-awesome.angle-right-regular"></svg-vue>
                            </router-link>
                        </td>
                    </tr>
                    </tbody>
                </table>
                </div>
            </div>

            <template v-else-if="!loading">
                <div class="my-6 bg-white shadow overflow-hidden sm:rounded">
                    <empty-state />
                </div>
            </template>
        </div>
    </main>
</template>

<script>
export default {
    name: "process-steps-list",
    metaInfo() {
        return {
            title: this.$i18n.t('Process steps')
        }
    },
    data() {
        return {
            loading: true,
            processStepList: [],
            activeTab: 'digital-media',
        }
    },
    computed: {
        groupedProcessSteps() {
            const groupOrder = ['digital-media', 'print-media'];
            const groupTitles = {
                'digital-media': 'Digital media',
                'print-media': 'Print media',
            };

            const buckets = {};
            this.processStepList.forEach((step) => {
                const slug = (((step || {}).process_step_category || {}).slug) || 'other';
                if (!buckets[slug]) {
                    buckets[slug] = [];
                }
                buckets[slug].push(step);
            });

            const orderedSlugs = [
                ...groupOrder.filter((slug) => !!buckets[slug]),
                ...Object.keys(buckets).filter((slug) => !groupOrder.includes(slug)).sort(),
            ];

            return orderedSlugs.map((slug) => ({
                slug: slug,
                title: groupTitles[slug] || ((((buckets[slug][0] || {}).process_step_category || {}).name) || slug),
                items: buckets[slug].slice().sort((a, b) => {
                    const aValue = Number(a.system_value || a.value || 0);
                    const bValue = Number(b.system_value || b.value || 0);
                    return aValue - bValue;
                }),
            }));
        },
        tabs() {
            return this.groupedProcessSteps;
        },
        activeTabItems() {
            const current = this.groupedProcessSteps.find((group) => group.slug === this.activeTab);
            return current ? current.items : [];
        },
    },
    watch: {
        tabs: {
            handler(newTabs) {
                if (!newTabs.length) {
                    return;
                }
                if (!newTabs.find((tab) => tab.slug === this.activeTab)) {
                    this.activeTab = newTabs[0].slug;
                }
            },
            immediate: true,
        },
    },
    mounted() {
        this.getProcessSteps();
    },
    methods: {
        getProcessSteps() {
            const self = this;
            self.loading = true;
            axios.get('api/workspace/admin/process-steps').then(function (response) {
                self.processStepList = response.data;
                self.loading = false;
            }).catch(function () {
                self.loading = false;
            });
        }
    }
}
</script>
